import { useSelector } from 'react-redux';
import { getGroupsSelector } from './selectors';
import { GroupData } from './types';
import { AppState } from '../../base/types';

export function useGroups(): GroupData[] {
    return useSelector((state: AppState) => getGroupsSelector(state, false));
}